// NEED Import mixin sortedProducts

import enums from "@/enums";

const getDiscountDom = {
  data() {
    return {
      findDiscountDD: 0,
    }
  },
  methods: {
    getDiscountDom(range = null) {
      if (!range) {
        return this.findDiscountDD;
      }

      const findDiscountDD = (energy, customerType) => {
        return energy && energy.details && energy.details.discountDD && (typeof energy.details.discountDD[customerType] === 'number') ?
          -energy.details.discountDD[customerType] : 0;
      }
      const keyByCustomerType = this.isPro ? 'priceEuro' : 'priceEuroVAT';
      this.findDiscountDD = findDiscountDD(range[enums.energyEnum.ELECTRICITY], keyByCustomerType) + findDiscountDD(range[enums.energyEnum.GAS], keyByCustomerType);
    }
  }
}

export default getDiscountDom;



// WEBPACK FOOTER //
// ./src/mixins/getDiscountDom.js